import styled from 'styled-components'

import { _S_Normal, _XS_Bold, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const Root = styled.div`
  border-left: 2px solid ${mainColors.neutralDark};
  padding: 4px 0 4px 12px;
  margin: 0 0 8px 16px;
`

export const Head = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`

export const Author = styled.span`
  ${_XS_Bold};
  color: ${mainColors.primaryMedium};
  overflow-wrap: anywhere;
`

export const Meta = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const Body = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.5;
  max-width: 60ch;
  margin: 4px 0 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`
